import React from 'react';
import { Helmet } from 'react-helmet-async';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import ChangeInsightsAnalysisContainer from '../../../containers/change-insights/ChangeInsightsAnalysisContainer.jsx';

const ChangeInsightsAnalysis = ({
  initiativeId,
  initiativeType,
  changeInsightId,
}) => (
  <>
    <Helmet>
      <title>Feedback Results | ChangeSync</title>
    </Helmet>
    <ChangeInsightsAnalysisContainer
      initiativeId={initiativeId}
      initiativeType={initiativeType}
      changeInsightId={changeInsightId}
    />
  </>
);

ChangeInsightsAnalysis.getInitialProps = ({ query }) => ({
  initiativeId: Number(query.initiativeId),
  initiativeType: query.initiativeType,
  changeInsightId: query.changeInsightId
    ? Number(query.changeInsightId)
    : undefined,
});

export default requireAuth(withRouterParams(ChangeInsightsAnalysis));
